import script from "./FilterPresetsControl.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterPresetsControl.vue?vue&type=script&setup=true&lang=js"

import "./FilterPresetsControl.vue?vue&type=style&index=0&id=2b912e8c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b912e8c"]])

export default __exports__